<template>
        <client-page>
            <form-mail></form-mail>
        </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import MainHeader from "@/components/client/en/inc/main-header.vue";
import FormMail from "@/components/client/en/demo/form-mail.vue"
export default {
    components: {
        MainHeader,
        FormMail,
        ClientPage
    }
};
</script>
